



















import Vue from "vue";

export default Vue.extend({
  name: "LateFeesCard",
  props: {
    unpaidLateFeeCount: { type: Number }
  },
  methods: {
    redirectToLateFees() {
      this.$router.push("/payments?myPlayers=true");
    }
  }
});
